import React, { useState, useEffect, useRef } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import FlightTabs from "../AllTabs/FlightTabs";

const FlightSupplierReport = () => {
    const { user, loading } = useAuth();
    const wrapperRef = useRef(null);

    const getTodayDate = () => {
        const today = new Date();
        const offset = today.getTimezoneOffset();
        const localDate = new Date(today.getTime() - offset * 60 * 1000);
        return localDate.toISOString().split("T")[0];
    };

    const getFirstDayOfMonth = () => {
        const date = new Date();
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        const offset = firstDay.getTimezoneOffset();
        const localDate = new Date(firstDay.getTime() - offset * 60 * 1000);
        return localDate.toISOString().split("T")[0];
    };

    const [pageLoading, setPageLoading] = useState(false);
    const [lists, setLists] = useState([]);
    const [totalSupplierPrice, setTotalSupplierPrice] = useState(0);

    const [fromDate, setFromDate] = useState(getFirstDayOfMonth());
    const [toDate, setToDate] = useState(getTodayDate());
    const [bookingStatus, setBookingStatus] = useState("");

    const [supplierId, setSupplierId] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [allCompanies, setAllCompanies] = useState([]);
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);

    const GetSupplierCompanies = async () => {
        try {
            const response = await apiService.getWithParams(
                `${config.GETCOMPANIES}?companyType=SUPPLIER`
            );

            if (response.data) {
                setAllCompanies(response.data);
            }
        } catch (error) {
            console.error("Failed to fetch supplier companies", error);
        }
    };

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);

        if (value.trim() === "") {
            setSupplierId("");
            setSuggestions([]);
            setShowSuggestions(false);
            return;
        }

        const searchLower = value.toLowerCase();
        const filtered = allCompanies.filter(c =>
            (c.companyName && c.companyName.toLowerCase().includes(searchLower)) ||
            (c.brandName && c.brandName.toLowerCase().includes(searchLower)) ||
            (c.email && c.email.toLowerCase().includes(searchLower))
        );

        setSuggestions(filtered);
        setShowSuggestions(true);
    };


    const handleSelectSupplier = (company) => {
        setSupplierId(company.companyId);
        setSearchTerm(company.companyName);
        setShowSuggestions(false);
    };


    const GetReportData = async (overrideParams = null) => {
        if (!user?.cid) return;

        setPageLoading(true);

        const requestPayload = overrideParams || {
            CompanyId: user.cid,
            SupplierId: supplierId || null,
            BookingStatus: bookingStatus || null,
            FromDate: fromDate || null,
            ToDate: toDate || null,
        };

        try {
            const res = await apiService.post(
                config.FLIGHTSUPPLIERREPORT,
                requestPayload
            );

            console.log("--- API Response Data ---");
            console.log(res);

            if (res) {
                setLists(res);
                const total = res.reduce(
                    (sum, item) => sum + (item.supplierPrice || 0),
                    0
                );
                setTotalSupplierPrice(total);
            }
        } catch (error) {
            console.error("Failed to fetch supplier report data:", error);
            setLists([]);
            setTotalSupplierPrice(0);
        } finally {
            setPageLoading(false);
        }
    };


    const handleReset = () => {
        const defaultFrom = getFirstDayOfMonth();
        const defaultTo = getTodayDate();
        setSupplierId("");
        setSearchTerm("");
        setBookingStatus("");
        setFromDate(defaultFrom);
        setToDate(defaultTo);
        setSuggestions([]);
        setShowSuggestions(false);

        GetReportData({
            CompanyId: user.cid,
            SupplierId: null,
            BookingStatus: null,
            FromDate: defaultFrom,
            ToDate: defaultTo
        });
    };


    useEffect(() => {
        if (user && !loading) {
            GetSupplierCompanies();
            GetReportData();
        }
    }, [user, loading]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowSuggestions(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [wrapperRef]);

    const formatDate = (dateString) => {
        if (!dateString) return "";
        return new Date(dateString).toLocaleDateString();
    };

    if (loading) return <p>Loading...</p>;

    return (
        <div id="layout-wrapper">
             <Header User={user} activeSection="flights" />
                 
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="p-2">
                                    <FlightTabs pageName="SUPPLIERREPORT" />
                                </div>

                                <div className="card-body">
                                    {/* --- Filter Section --- */}
                                    <div className="row mb-4 g-3">

                                        <div className="col-md-3 position-relative" ref={wrapperRef}>
                                            <label className="form-label">Supplier Name</label>
                                            <div className="input-group">
                                                <span className="input-group-text"><i className="ri-search-line"></i></span>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Search Supplier..."
                                                    value={searchTerm}
                                                    onChange={handleSearchChange}
                                                    onFocus={() => {
                                                        if (searchTerm) setShowSuggestions(true);
                                                    }}
                                                    autoComplete="off"
                                                />
                                                
                                            </div>

                                            {/* Suggestions Dropdown */}
                                            {showSuggestions && suggestions.length > 0 && (
                                                <div
                                                    className="card position-absolute w-100 shadow"
                                                    style={{ zIndex: 1000, maxHeight: "300px", overflowY: "auto", top: "100%" }}
                                                >
                                                    <ul className="list-group list-group-flush">
                                                        {suggestions.map((company) => (
                                                            <li
                                                                key={company.companyId}
                                                                className="list-group-item list-group-item-action cursor-pointer"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={() => handleSelectSupplier(company)}
                                                            >
                                                                <div className="d-flex align-items-center">
                                                                    <i className="ri-building-2-line me-2 text-primary"></i>
                                                                    <div>
                                                                        <div className="fw-bold">{company.companyName}</div>
                                                                        <small className="text-muted">{company.email}</small>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}

                                            {/* Empty State */}
                                            {showSuggestions && suggestions.length === 0 && searchTerm && (
                                                <div
                                                    className="card position-absolute w-100 shadow p-2 text-center text-muted"
                                                    style={{ zIndex: 1000, top: "100%" }}
                                                >
                                                    No suppliers found
                                                </div>
                                            )}
                                        </div>

                                        <div className="col-md-2">
                                            <label className="form-label">From Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={fromDate}
                                                onChange={(e) => setFromDate(e.target.value)}
                                            />
                                        </div>

                                        <div className="col-md-2">
                                            <label className="form-label">To Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={toDate}
                                                onChange={(e) => setToDate(e.target.value)}
                                            />
                                        </div>

                                        <div className="col-md-2">
                                            <label className="form-label">Booking Status</label>
                                            <select
                                                className="form-select"
                                                value={bookingStatus}
                                                onChange={(e) => setBookingStatus(e.target.value)}
                                            >
                                                <option value="">All Statuses</option>
                                                <option value="CONFIRMED">CONFIRMED</option>
                                                <option value="CANCELLED">CANCELLED</option>
                                                <option value="PENDING">PENDING</option>
                                                <option value="FAILED">FAILED</option>
                                            </select>
                                        </div>

                                        {/* Buttons Column */}
                                        <div className="col-auto d-flex align-items-end">
                                            <button
                                                className="btn btn-primary me-2"
                                                onClick={() => GetReportData(null)}
                                            >
                                                <i className="ri-search-line align-bottom me-1"></i> Search Report
                                            </button>

                                            <button
                                                className="btn btn-danger"
                                                onClick={handleReset}
                                            >
                                                <i className="ri-refresh-line align-bottom me-1"></i> Reset
                                            </button>



                                        </div>

                                    </div>


                                    {/* --- Table Section --- */}
                                    <div className="table-responsive table-card p-2">
                                        <table
                                            className="table align-middle table-striped table-hover"
                                            id="supplierReportTable"
                                        >
                                            <thead className="bg-soft-info bg-gradient">
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Booking No</th>
                                                    {/* <th>PNR</th> */}
                                                    <th>Booking Date</th>
                                                    <th>Supplier Name</th>
                                                    <th>Route</th>
                                                    <th>Passenger</th>
                                                    <th>Booking Status</th>
                                                    <th className="text-end">Supplier Price</th>
                                                </tr>
                                            </thead>
                                            {pageLoading ? (
                                                <tbody>
                                                    <tr>
                                                        <td colSpan="9" className="text-center">
                                                            <img
                                                                src="/assets/images/loader.webp"
                                                                width="64px"
                                                                height="64px"
                                                                alt="Loading..."
                                                            />
                                                            <p>Generating Report...</p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            ) : (
                                                <>
                                                    <tbody className="list form-check-all">
                                                        {lists.length > 0 ? (
                                                            lists.map((item, index) => (
                                                                <tr key={item.flightBookingId || index}>
                                                                    <td>{index + 1}</td>
                                                                    <td>{item.bookingNo}</td>
                                                                    {/* <td>{item.pnr}</td> */}
                                                                    <td>{formatDate(item.bookingDate)}</td>
                                                                    <td>{item.supplierName}</td>
                                                                    <td>{item.route}</td>
                                                                    <td>{item.passengerName}</td>
                                                                    <td>
                                                                        {item.status === "CONFIRMED" ? (
                                                                            <span className="badge bg-success">
                                                                                {item.status}
                                                                            </span>
                                                                        ) : item.status === "CANCELLED" ? (
                                                                            <span className="badge bg-danger">
                                                                                {item.status}
                                                                            </span>
                                                                        ) : (
                                                                            <span className="badge bg-warning text-dark">
                                                                                {item.status}
                                                                            </span>
                                                                        )}
                                                                    </td>
                                                                    <td className="text-end">
                                                                        {item.supplierPrice?.toFixed(2)}
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="9" className="text-center">
                                                                    No records found. Please adjust filters.
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <td
                                                                colSpan="8"
                                                                className="text-end fw-bold fs-14"
                                                            >
                                                                Grand Total (Supplier Cost):
                                                            </td>
                                                            <td className="fw-bold fs-14 text-end text-success">
                                                                {totalSupplierPrice.toFixed(2)}
                                                            </td>
                                                        </tr>
                                                    </tfoot>
                                                </>
                                            )}
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FlightSupplierReport;